import React from 'react';
import { useParams } from 'react-router-dom';
import ResourceDetail from '../components/Resources/ResourceDetail';

const ResourceDetailPage: React.FC = () => {
  const { performanceId } = useParams<{ performanceId: string }>();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <ResourceDetail performanceId={performanceId} />
      </div>
    </div>
  );
};

export default ResourceDetailPage;